/* eslint-disable max-len */
export const ProductConstants = {
  IS_ENABLED: 'enabled == true && in_stock == true',
  IS_SPECIAL:
    'enabled == true && in_stock == true && variants_0_price != variants_0_sale_price && variants_0_sale_price > 0',
};
